module.exports = __webpack_public_path__ + "img/40_38_040_730.d6f560fa.jpg";